export default class DeviceCount {
  APMAC?: string
  timestamp?: Date
  stayCount?: number
  nonstayCount?: number

  constructor(attrs = {}) {
    Object.assign(this, attrs)
  }
}